import React from "react";
import { useConfigQuery } from "services/staticDataService";

const DashboardReportsV3 = ({
  children,
  variant = "default",
  viewportFill = false,
}) => {
  const viewportFillStyle = viewportFill
    ? {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
      }
    : {};

  const { data: styleOverrides } = useConfigQuery("style_overrides");

  const { watermarkText, watermarkStyles = {}, ...dashboardStyles } =
    styleOverrides?.dashboard?.[variant] ?? {};

  const watermarkBackground =
    watermarkText != null
      ? (() => {
          const fontFamily = watermarkStyles?.fontFamily ?? "sans-serif";
          const fontSize = watermarkStyles?.fontSize ?? "4rem";
          const color = watermarkStyles?.color ?? "rgba(0, 0, 0, 0.05)";
          const fontWeight = watermarkStyles?.fontWeight ?? "bold";
          const angle = parseFloat(watermarkStyles?.angle ?? "-30");
          const baseSpacing = parseFloat(watermarkStyles?.spacing ?? "300");

          const angleRad = Math.abs(angle) * (Math.PI / 180);
          const tileSize = Math.max(
            baseSpacing,
            baseSpacing *
              (Math.abs(Math.sin(angleRad)) + Math.abs(Math.cos(angleRad)))
          );

          const svg = `<svg width="${tileSize}" height="${tileSize}" xmlns="http://www.w3.org/2000/svg">
          <text
            x="${tileSize / 2}"
            y="${tileSize / 2}"
            style="
              font-family: ${fontFamily};
              font-size: ${fontSize};
              font-weight: ${fontWeight};
              fill: ${color};
              text-anchor: middle;
              dominant-baseline: middle;
              transform: rotate(${angle}deg);
              transform-origin: center;
            "
          >${watermarkText}</text>
        </svg>`
            .replace(/[\r\n]+/g, "")
            .replace(/\s+/g, " ")
            .trim();

          return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
        })()
      : null;

  return (
    <div
      className={`dashboard variant-${variant}`}
      style={{
        ...dashboardStyles,
        ...(watermarkBackground && {
          backgroundImage: watermarkBackground,
          backgroundRepeat: "repeat",
        }),
        ...viewportFillStyle,
      }}
    >
      {children}
    </div>
  );
};

export default DashboardReportsV3;
